module.exports = __webpack_public_path__ + "static/media/oborudovanie_dlya_mp.a3570177.pdf";